@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.random.image.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/waifupics.modules.features.random.image.generated.resources/"

@delegate:ResourceContentHash(-1_403_334_444)
internal val Res.string.age_rating: StringResource by lazy {
      StringResource("string:age_rating", "age_rating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 34),
      ))
    }

@delegate:ResourceContentHash(-1_413_167_316)
internal val Res.string.allow: StringResource by lazy {
      StringResource("string:allow", "allow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45, 21),
      ))
    }

@delegate:ResourceContentHash(-71_469_583)
internal val Res.string.borderline: StringResource by lazy {
      StringResource("string:borderline", "borderline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67, 34),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 102, 22),
      ))
    }

@delegate:ResourceContentHash(1_052_205_677)
internal val Res.string.close_full_image: StringResource by lazy {
      StringResource("string:close_full_image", "close_full_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125, 40),
      ))
    }

@delegate:ResourceContentHash(619_700_502)
internal val Res.string.close_image_information: StringResource by lazy {
      StringResource("string:close_image_information", "close_image_information", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 166, 63),
      ))
    }

@delegate:ResourceContentHash(80_128_799)
internal val Res.string.color_palette: StringResource by lazy {
      StringResource("string:color_palette", "color_palette", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 230, 41),
      ))
    }

@delegate:ResourceContentHash(1_839_709_585)
internal val Res.string.copy_image_source: StringResource by lazy {
      StringResource("string:copy_image_source", "copy_image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 272, 37),
      ))
    }

@delegate:ResourceContentHash(187_981_282)
internal val Res.string.copy_palette_color: StringResource by lazy {
      StringResource("string:copy_palette_color", "copy_palette_color", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 310, 46),
      ))
    }

@delegate:ResourceContentHash(-1_867_054_547)
internal val Res.string.explicit_18: StringResource by lazy {
      StringResource("string:explicit_18", "explicit_18", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 357, 39),
      ))
    }

@delegate:ResourceContentHash(-1_930_113_456)
internal val Res.string.feed_load_failed: StringResource by lazy {
      StringResource("string:feed_load_failed", "feed_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 397, 76),
      ))
    }

@delegate:ResourceContentHash(-1_963_583_832)
internal val Res.string.filter: StringResource by lazy {
      StringResource("string:filter", "filter", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 474, 22),
      ))
    }

@delegate:ResourceContentHash(-516_491_140)
internal val Res.string.full_image: StringResource by lazy {
      StringResource("string:full_image", "full_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 497, 34),
      ))
    }

@delegate:ResourceContentHash(-1_904_475_386)
internal val Res.string.image_author: StringResource by lazy {
      StringResource("string:image_author", "image_author", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 532, 28),
      ))
    }

@delegate:ResourceContentHash(-1_691_003_126)
internal val Res.string.image_copied: StringResource by lazy {
      StringResource("string:image_copied", "image_copied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 561, 28),
      ))
    }

@delegate:ResourceContentHash(1_512_401_708)
internal val Res.string.image_copy_failed: StringResource by lazy {
      StringResource("string:image_copy_failed", "image_copy_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 590, 65),
      ))
    }

@delegate:ResourceContentHash(148_823_281)
internal val Res.string.image_info: StringResource by lazy {
      StringResource("string:image_info", "image_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 706, 26),
      ))
    }

@delegate:ResourceContentHash(-1_256_700_796)
internal val Res.string.image_information: StringResource by lazy {
      StringResource("string:image_information", "image_information", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 656, 49),
      ))
    }

@delegate:ResourceContentHash(-569_497_372)
internal val Res.string.image_load_failed: StringResource by lazy {
      StringResource("string:image_load_failed", "image_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 733, 53),
      ))
    }

@delegate:ResourceContentHash(1_103_269_850)
internal val Res.string.image_load_hint: StringResource by lazy {
      StringResource("string:image_load_hint", "image_load_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 87),
      ))
    }

@delegate:ResourceContentHash(1_484_235_183)
internal val Res.string.image_not_provided: StringResource by lazy {
      StringResource("string:image_not_provided", "image_not_provided", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 875, 42),
      ))
    }

@delegate:ResourceContentHash(515_254_300)
internal val Res.string.image_palette_copy_hint: StringResource by lazy {
      StringResource("string:image_palette_copy_hint", "image_palette_copy_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 918, 63),
      ))
    }

@delegate:ResourceContentHash(80_124_366)
internal val Res.string.image_palette_title: StringResource by lazy {
      StringResource("string:image_palette_title", "image_palette_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 982, 47),
      ))
    }

@delegate:ResourceContentHash(-340_272_781)
internal val Res.string.image_report_message: StringResource by lazy {
      StringResource("string:image_report_message", "image_report_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1030, 120),
      ))
    }

@delegate:ResourceContentHash(-1_681_358_665)
internal val Res.string.image_size: StringResource by lazy {
      StringResource("string:image_size", "image_size", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1222, 34),
      ))
    }

@delegate:ResourceContentHash(874_887_777)
internal val Res.string.image_size_pending: StringResource by lazy {
      StringResource("string:image_size_pending", "image_size_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1151, 70),
      ))
    }

@delegate:ResourceContentHash(920_704_925)
internal val Res.string.image_source: StringResource by lazy {
      StringResource("string:image_source", "image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1322, 28),
      ))
    }

@delegate:ResourceContentHash(-1_528_395_013)
internal val Res.string.image_source_open_failed: StringResource by lazy {
      StringResource("string:image_source_open_failed", "image_source_open_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1257, 64),
      ))
    }

@delegate:ResourceContentHash(254_778_861)
internal val Res.string.image_tags: StringResource by lazy {
      StringResource("string:image_tags", "image_tags", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1351, 26),
      ))
    }

@delegate:ResourceContentHash(1_123_524_345)
internal val Res.string.loading_image: StringResource by lazy {
      StringResource("string:loading_image", "loading_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1378, 41),
      ))
    }

@delegate:ResourceContentHash(1_107_814_812)
internal val Res.string.loading_more_images: StringResource by lazy {
      StringResource("string:loading_more_images", "loading_more_images", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1420, 55),
      ))
    }

@delegate:ResourceContentHash(1_409_710_461)
internal val Res.string.open_image_source: StringResource by lazy {
      StringResource("string:open_image_source", "open_image_source", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1476, 41),
      ))
    }

@delegate:ResourceContentHash(859_292_464)
internal val Res.string.original_image_size: StringResource by lazy {
      StringResource("string:original_image_size", "original_image_size", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1518, 59),
      ))
    }

@delegate:ResourceContentHash(1_894_511_142)
internal val Res.string.refresh: StringResource by lazy {
      StringResource("string:refresh", "refresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1578, 27),
      ))
    }

@delegate:ResourceContentHash(-1_656_346_608)
internal val Res.string.report_title: StringResource by lazy {
      StringResource("string:report_title", "report_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1606, 28),
      ))
    }

@delegate:ResourceContentHash(1_920_174_884)
internal val Res.string.reset_image_zoom: StringResource by lazy {
      StringResource("string:reset_image_zoom", "reset_image_zoom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1635, 40),
      ))
    }

@delegate:ResourceContentHash(-1_721_829_073)
internal val Res.string.retry_loading: StringResource by lazy {
      StringResource("string:retry_loading", "retry_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1676, 29),
      ))
    }

@delegate:ResourceContentHash(-1_582_237_413)
internal val Res.string.safe_for_work: StringResource by lazy {
      StringResource("string:safe_for_work", "safe_for_work", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1706, 41),
      ))
    }

@delegate:ResourceContentHash(1_478_240_639)
internal val Res.string.something_wrong: StringResource by lazy {
      StringResource("string:something_wrong", "something_wrong", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1748, 43),
      ))
    }

@delegate:ResourceContentHash(-1_503_567_278)
internal val Res.string.suggestive: StringResource by lazy {
      StringResource("string:suggestive", "suggestive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1792, 34),
      ))
    }

@delegate:ResourceContentHash(-995_227_543)
internal val Res.string.zoomed_image: StringResource by lazy {
      StringResource("string:zoomed_image", "zoomed_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1827, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("age_rating", Res.string.age_rating)
  map.put("allow", Res.string.allow)
  map.put("borderline", Res.string.borderline)
  map.put("cancel", Res.string.cancel)
  map.put("close_full_image", Res.string.close_full_image)
  map.put("close_image_information", Res.string.close_image_information)
  map.put("color_palette", Res.string.color_palette)
  map.put("copy_image_source", Res.string.copy_image_source)
  map.put("copy_palette_color", Res.string.copy_palette_color)
  map.put("explicit_18", Res.string.explicit_18)
  map.put("feed_load_failed", Res.string.feed_load_failed)
  map.put("filter", Res.string.filter)
  map.put("full_image", Res.string.full_image)
  map.put("image_author", Res.string.image_author)
  map.put("image_copied", Res.string.image_copied)
  map.put("image_copy_failed", Res.string.image_copy_failed)
  map.put("image_info", Res.string.image_info)
  map.put("image_information", Res.string.image_information)
  map.put("image_load_failed", Res.string.image_load_failed)
  map.put("image_load_hint", Res.string.image_load_hint)
  map.put("image_not_provided", Res.string.image_not_provided)
  map.put("image_palette_copy_hint", Res.string.image_palette_copy_hint)
  map.put("image_palette_title", Res.string.image_palette_title)
  map.put("image_report_message", Res.string.image_report_message)
  map.put("image_size", Res.string.image_size)
  map.put("image_size_pending", Res.string.image_size_pending)
  map.put("image_source", Res.string.image_source)
  map.put("image_source_open_failed", Res.string.image_source_open_failed)
  map.put("image_tags", Res.string.image_tags)
  map.put("loading_image", Res.string.loading_image)
  map.put("loading_more_images", Res.string.loading_more_images)
  map.put("open_image_source", Res.string.open_image_source)
  map.put("original_image_size", Res.string.original_image_size)
  map.put("refresh", Res.string.refresh)
  map.put("report_title", Res.string.report_title)
  map.put("reset_image_zoom", Res.string.reset_image_zoom)
  map.put("retry_loading", Res.string.retry_loading)
  map.put("safe_for_work", Res.string.safe_for_work)
  map.put("something_wrong", Res.string.something_wrong)
  map.put("suggestive", Res.string.suggestive)
  map.put("zoomed_image", Res.string.zoomed_image)
}
